/* Add one real Shopify variant while preserving the native cart and checkout. */
if (!customElements.get('bm-cart-offer')) {
  customElements.define('bm-cart-offer', class BMCartOffer extends HTMLElement {
    connectedCallback() {
      if (this.initialized) return;
      try { this.config = JSON.parse(this.querySelector('[data-bm-offer-config]').textContent); } catch { return; }
      this.initialized = true; this.busy = false; this.abort = new AbortController();
      this.form = this.querySelector('[data-bm-offer-form]');
      this.design = this.querySelector('[data-bm-offer-design]');
      this.size = this.querySelector('[data-bm-offer-size]');
      this.button = this.querySelector('[data-bm-offer-add]');
      this.error = this.querySelector('[data-bm-offer-error]');
      this.design.replaceChildren();
      this.config.products.forEach(product => this.design.add(new Option(product.title, String(product.id))));
      this.design.addEventListener('change', event => { event.stopPropagation(); this.renderSizes(); }, { signal: this.abort.signal });
      this.size.addEventListener('change', event => { event.stopPropagation(); this.update(); }, { signal: this.abort.signal });
      this.button.addEventListener('click', event => this.submit(event), { signal: this.abort.signal });
      this.form.hidden = false; this.renderSizes();
    }
    disconnectedCallback() { this.abort?.abort(); this.initialized = false; }
    product() { return this.config.products.find(product => String(product.id) === this.design.value); }
    variant() { return this.product()?.variants.find(variant => String(variant.id) === this.size.value); }
    money(value) { try { return new Intl.NumberFormat(this.config.locale, { style: 'currency', currency: this.config.currency }).format(value / 100); } catch { return (value / 100).toFixed(2) + ' ' + this.config.currency; } }
    renderSizes() {
      this.size.replaceChildren(new Option('Choose a size', ''));
      this.product()?.variants.forEach(variant => {
        const option = new Option((variant.title === 'Default Title' ? 'One size' : variant.title) + (variant.available ? '' : ' · Sold out'), String(variant.id));
        option.disabled = !variant.available; this.size.add(option);
      });
      this.error.hidden = true; this.update();
    }
    update() {
      const variant = this.variant();
      this.button.textContent = this.busy ? 'Adding…' : variant ? 'Add belt — ' + this.money(variant.price) : 'Add belt to bag';
      this.button.disabled = this.busy; this.design.disabled = this.busy; this.size.disabled = this.busy;
    }
    async submit(event) {
      event.preventDefault(); if (this.busy) return;
      this.error.hidden = true;
      const variant = this.variant();
      if (!variant?.available) { this.error.textContent = 'Choose an available size first.'; this.error.hidden = false; this.size.focus(); return; }
      const productTitle = this.product().title;
      const drawer = document.querySelector('cart-drawer');
      const sections = drawer?.getSectionsToRender?.() || [];
      const body = { items: [{ id: variant.id, quantity: 1 }] };
      if (sections.length) { body.sections = sections.map(section => section.id); body.sections_url = location.pathname; }
      this.busy = true; this.form.setAttribute('aria-busy', 'true'); this.update();
      let added = false;
      try {
        const response = await fetch(this.config.addUrl, { method: 'POST', credentials: 'same-origin', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify(body) });
        const result = await response.json();
        if (!response.ok || result.status) throw new Error(result.description || result.message || 'This belt could not be added. Please try again.');
        added = true;
        const usable = sections.length && sections.every(section => result.sections?.[section.id] && new DOMParser().parseFromString(result.sections[section.id], 'text/html').querySelector(section.selector || '.shopify-section'));
        if (this.config.cartPage || !drawer?.renderContents || !usable) { location.assign(this.config.cartUrl); return; }
        drawer.classList.remove('is-empty'); drawer.renderContents(result);
        const message = drawer.querySelector('[data-bm-cart-message]');
        if (message) {
          message.textContent = 'Added ' + productTitle + ' · ' + (variant.title === 'Default Title' ? 'One size' : variant.title) + ' to your bag.';
          message.setAttribute('tabindex', '-1');
          if (typeof trapFocus === 'function') trapFocus(drawer.querySelector('#CartDrawer'), message);
          else message.focus({ preventScroll: true });
        }
        if (typeof publish === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') publish(PUB_SUB_EVENTS.cartUpdate, { source: 'bm-cart-offer', cartData: result }).catch(() => {});
      } catch (error) {
        if (added) location.assign(this.config.cartUrl);
        else { this.error.textContent = error.message || 'Connection interrupted. Check your bag before trying again.'; this.error.hidden = false; }
      } finally { this.busy = false; this.form.removeAttribute('aria-busy'); this.update(); }
    }
  });
}
